const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Track AI Generate Learning Topic component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('addTopics', [
  'Application',
  'appConfiguration',
  '$http',
  '$translate',
  function (Application, appConfiguration, $http, $translate) {
    return {
      restrict: 'E',
      replace: false,
      scope: {
        source: '=',
        learnItems: '=',
        sections: '=',
        instructions: '=',
        onTopicChange: '&',
      },
      template: require('../../../templates/directives/cms/add-topics.html'),
      controller: ['$scope', function ($scope) {
        $scope.generativeInProgress = false;
        $scope.generativeEnabled = Application.features.flags().enable_generative_ai;
        $scope.editTopic = {
          generateTopics: async function () {
            let goodContent = 0;
            if ($scope.generativeInProgress) {
              return;
            }
            for (const section of $scope.sections) {
              for (const course of section.courses) {
                if (course.article || course.file || course.video || course.scorm) {
                  goodContent += 1;
                }
              }
            }
            if (goodContent > 1) {
              try {
                $scope.generativeInProgress = true;
                const resp = await $http.post(appConfiguration.apiUrl + '/graphql', {
                  query:
                    'query { generativeTopics(trackid:"' +
                    $scope.source.trim().replaceAll('\n', '').replaceAll('"', '') +
                    '") }',
                });
                if (!$scope.learnItems) {
                  $scope.learnItems = [];
                }
                if (resp.data.data) {
                  if ($scope.onTopicChange) {
                    $scope.onTopicChange({ topics: resp.data.data.generativeTopics });
                  }
                  $scope.generativeInProgress = false;
                }
              } catch (error) {
                console.log('Error occurred getting generated learning topics ', error);
                $scope.generativeInProgress = false;
              }
            } else {
              Application.notifications.setError(
                self.translations['modules.notifications.unableToGenerateTrackLearnItems']
              );
              $scope.generativeInProgress = false;
            }
          },
        };
        $translate(['modules.notifications.unableToGenerateTrackLearnItems']).then(function (
          translations
        ) {
          self.translations = translations;
        });
      }],
    };
  },
]);
